var map = {
	"./american.png": "d3ad",
	"./americanSamoa.png": "a1c6",
	"./anguilla.png": "c577",
	"./antiguaAndBarbuda.png": "9c54",
	"./aruba.png": "0443",
	"./bahamas.png": "5f4b",
	"./bahrain.png": "0bb6",
	"./barbados.png": "57ef",
	"./belize.png": "aeca",
	"./bermuda.png": "a760",
	"./britishVirginIslands.png": "609e",
	"./caboVerde.png": "b13d",
	"./caymanIslands.png": "914f",
	"./comoros.png": "9b2a",
	"./cookIslands.png": "4158",
	"./cuba.png": "5125",
	"./curacao.png": "605e",
	"./dominica.png": "e1c2",
	"./dominicanRepublic.png": "7c46",
	"./fiji.png": "b48d",
	"./grenada.png": "c12b",
	"./guadeloupe.png": "cfe8",
	"./guineaBissau.png": "8566",
	"./guyana.png": "6ec6",
	"./haiti.png": "4131",
	"./jamaica.png": "0f00",
	"./kiribati.png": "a0ef",
	"./kittsAndNevis.png": "7ed9",
	"./maldives.png": "e8af",
	"./marshallIslands.png": "302c",
	"./martinique.png": "1bf8",
	"./mauritius.png": "c806",
	"./micronesia.png": "5b85",
	"./montserrat.png": "cb1e",
	"./nauru.png": "ad8d",
	"./niue.png": "fdc2",
	"./palau.png": "ab1b",
	"./papuaNewGuinea.png": "07c7",
	"./puertoRico.png": "5252",
	"./saintLucia.png": "215f",
	"./samoa.png": "00e1",
	"./saoTomeAndPrincipe.png": "d9a5",
	"./seychelles.png": "d13c",
	"./singapore.png": "015b",
	"./sintMaarten.png": "f3cd",
	"./solomonIslands.png": "f940",
	"./stKittsAndNevis.png": "b11b",
	"./stVincent.png": "8da4",
	"./stVincentAndTheGrenadines.png": "e365",
	"./suriname.png": "9b9f",
	"./timorLeste.png": "4112",
	"./tokelau.png": "154d",
	"./tonga.png": "d9b71",
	"./trinidadAndTobago.png": "6d4c",
	"./turksAndCaicos 2.png": "ed4c",
	"./turksAndCaicos.png": "2b27",
	"./tuvalu.png": "8c13",
	"./tuvaluRelief.png": "1e76a",
	"./vanuatu.png": "3319"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d54f";